import React, { useEffect, useRef } from "react";

import { Grid, TextField } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { hover } from "@testing-library/user-event/dist/hover";
interface SeachInputInterface {
  onCancelClick?: any;
  showSearch?: any;
  setSearchText?: any;
  searchText?: string;
}
export default function SearchInput({
  onCancelClick,
  showSearch,
  setSearchText,
  searchText
}: SeachInputInterface) {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    showSearch !== "" && inputRef.current?.focus();
  }, [showSearch]);
  return (
    <Grid
      container
      alignItems="center"
      sx={{
        backgroundColor: showSearch ? "#fff" : "rgba(0, 0, 0, 0.04)"
      }}
    >
      <TextField
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        inputRef={inputRef}
        label="Type to search..."
        variant="standard"
        color="secondary"
        sx={{
          m: 0.5,
          flex: 1
        }}
        size="small"
      />
      <CloseIcon
        color="primary"
        fontSize="small"
        onClick={onCancelClick}
        sx={{
          mr: 1,
          cursor: "pointer"
        }}
      />
    </Grid>
  );
}
